import { render, staticRenderFns } from "./FilterTree.vue?vue&type=template&id=f0878ff4&scoped=true"
import script from "./FilterTree.vue?vue&type=script&lang=js"
export * from "./FilterTree.vue?vue&type=script&lang=js"
import style0 from "./FilterTree.vue?vue&type=style&index=0&id=f0878ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0878ff4",
  null
  
)

export default component.exports